import { useState } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { BsEnvelopeFill, BsGeoAltFill, BsTelephoneFill } from "react-icons/bs";

export default function ContactUs() {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Thank you! We will get back to you soon.");
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <div className="contact-wrapper bg-white">
      <Container>
        <h2 className="fw-bold text-center">Get in Touch</h2>
        <p className="text-center mb-5 fw-normal">Have questions? Our team is here to help. Contact us today!</p>
        <Row className="g-4">
          {/* Contact Details */}
          <Col md={5}>
            <Card className="p-4 border-0 bg-light h-100">
              <h4 className="fw-bold">Contact Information</h4>
              <p className="mb-5">Reach out to us through any of the following channels.</p>
              <div className="d-flex align-items-start mb-3">
                <BsGeoAltFill size={24} className="text-primary me-3" />
                <div>
                  <div>238C/4R, Harwara, Dhoomanganj, Prayagraj</div>
                  <div>
                    Uttar Pradesh, 211011
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center mb-3">
                <BsTelephoneFill size={24} className="text-success me-3" />
                <span>+91 7800-111-018</span>
              </div>
              <div className="d-flex align-items-center">
                <BsEnvelopeFill size={24} className="text-danger me-3" />
                <span>support@on9estate.com</span>
              </div>
            </Card>
          </Col>

          {/* Contact Form */}
          <Col md={7}>
            <Card className="p-4 border-0 bg-light">
              <h5 className="fw-bold">Send Us a Message</h5>
              <Form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="email"
                        placeholder="Enter your email"
                        name="phoneNumber"
                        value={formData.phoneNumber}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </div>
                  <div className="col-lg-12 col-md-12 col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Message</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="Write your message here..."
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        required
                      />
                    </Form.Group>
                  </div>
                </div>
                <Button variant="primary" type="submit" className="w-100">
                  Send Message
                </Button>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}